import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  AzureMap,
  AzureMapDataSourceProvider,
  AzureMapFeature,
  AzureMapLayerProvider,
  AzureMapsProvider,
  AzureMapHtmlMarker,
  IAzureMapOptions,
  AzureMapPopup,
} from "react-azure-maps";

import {
  AuthenticationType,
  data,
  MapMouseEvent,
  PopupOptions,
} from "azure-maps-control";
import * as atlas from "azure-maps-control";

import { key } from "./key";

import marker3 from "../../Assests/marker3.svg";
import marker1 from "../../Assests/marker1.svg";
import products from "../../Assests/marker2.svg";
import capacity from "../../Assests/NewMarker2.svg";
import inBoundLine from "../../Assests/inbound-line.svg";
import locator from "../../Assests/locator.svg";

//
import processingPlant from "../../Assests/processing-plant.svg";
import processingPlantAdd from "../../Assests/processing-plant-add.svg";
import processingPlantCapacity from "../../Assests/processing-plant-capacity.svg";
import processingPlantRemove from "../../Assests/processing-plant-remove.svg";
import packagingPlant1 from "../../Assests/packaging-plant-blue.svg";
import packagingPlant2 from "../../Assests/packaging-plant-green.svg";
import packagingPlantCapacity from "../../Assests/packaging-plant-capacity.svg";
import packagingPlantRemove from "../../Assests/packaging-plant-remove.svg";
import supplierMap from "../../Assests/supplier.svg";
import inBoundtoSupplier from "../../Assests/inbound-to-supplier.svg";
import "./style.css";
import { memo, useEffect, useMemo, useRef, useState } from "react";
import { popup } from "react";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import {
  API_BASE_URL,
  GET_AZURE_MAP_DATA,
  NUTRITION_GET_AZURE_MAP_DATA,
  CGO_AZUREMAPS_GET_API,
} from "../../Utils/Config";
import { getRequest } from "../../Services/AxiosConfiguration";
import { red } from "@mui/material/colors";
import Loader from "../../Components/Modals/Loader";
export default function CGOHome() {
  const [resultData, setResultData] = useState({});
  const [nutritionResultData, setNUTRITIONResultData] = useState({});
  const [bubbleWidth, setBubbleWidth] = useState(40);
  const [bubbleHeight, setBubbleHeight] = useState(40);
  const [show1, setShow1] = useState(true);
  const [show2, setShow2] = useState(true);
  const [show3, setShow3] = useState(true);

  // suren
  //legends show hide
  const [showLegendDetails, setshowLegendDetails] = useState(false);

  //map filters show hid
  const [showMapFiltersDetails, setshowMapFiltersDetails] = useState(false);

  //  Hide and show  in Legend

  const [existingPlantShow, setExistingPlantShow] = useState(false);
  const [newPlantShow, setNewPlantShow] = useState(false);
  const [depotShow, setDepotShow] = useState(false);

  const { selectedScenarioData } = useSelector(
    (state) => state.InputDataReducers
  );
  console.log(
    selectedScenarioData?.scenario === "BaseLine",
    "selectedScenarioData"
  );

  const selectedUsecaseId = useSelector(
    (state) => state.InputDataReducers.selectedUsecaseId
  );
  const selectedCategoryId = useSelector(
    (state) => state.InputDataReducers.selectedCategoryId
  );

  const selectedFolderId = useSelector(
    (state) => state.InputDataReducers.selectedFolderId
  );

  const selectedScnarioId = useSelector(
    (state) => state.InputDataReducers.selectedScenarioId
  );

  const selectedTimeId = useSelector(
    (state) => state.InputDataReducers.selectedTimeId
  );

  useEffect(() => {
    getAzureMapData(selectedFolderId, selectedScnarioId);
  }, [selectedFolderId, selectedScnarioId]);

  useEffect(() => {
    setExistingPlantShow(false);
    setNewPlantShow(false);
    setDepotShow(false);
    setshowLegendDetails(false);
  }, [selectedFolderId, selectedScnarioId]);
  //let resultData={};
  const getAzureMapData = (folder_id, scenarioId) => {
    const urls = API_BASE_URL + CGO_AZUREMAPS_GET_API;
    const header = {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    };
    getRequest(urls, { folder_id: folder_id, scenario_id: scenarioId }, header)
      .then((response) => {
        console.log("Responseddddddd: ", response);

        let result = response.data;
        setResultData(result);
      })
      .catch((error) => {});
  };
  const nutritionGetAzureMapData = (
    usecaseId,
    category_Id,
    folder_id,
    scenarioId,
    Time_Period
  ) => {
    const urls = API_BASE_URL + NUTRITION_GET_AZURE_MAP_DATA;
    const header = {
      accept: "application/json",
      "Content-Type": "multipart/form-data",
    };
    getRequest(
      urls,
      {
        usecaseId: usecaseId,
        category_Id: category_Id,
        folder_id: folder_id,
        scenario_id: scenarioId,
        Time_Period: Time_Period,
      },
      header
    )
      .then((response) => {
        let result = response.data;
        setNUTRITIONResultData(result);
      })
      .catch((error) => {
        // dispatch(openErrorDialog(error));
      });
  };
  const nutritionPoints =
    nutritionResultData?.points?.length > 0 ? nutritionResultData?.points : [];

  const points = resultData?.points?.length > 0 ? resultData?.points : [];

  const nutritionCoordinates =
    nutritionResultData?.coordinates?.length > 0
      ? nutritionResultData?.coordinates
      : [];
  const coordinates =
    resultData?.coordinates?.length > 0 ? resultData?.coordinates : [];

  const nutritionPackaging =
    nutritionResultData?.packagingCoords?.length > 0
      ? nutritionResultData?.packagingCoords
      : [];

  const nutritionFactoryCoords =
    nutritionResultData?.factoryCoords?.length > 0
      ? nutritionResultData?.factoryCoords
      : [];

  const factoryCoords = [
    {
      latitude: 23.0145,
      longitude: 72.5918,
      text: "Ahmedabad",
      title: "Ahmedabad",
      total: 2000,
    },
    {
      latitude: 13.43,
      longitude: 77.72,
      text: "Chikkaballapur",
      title: "Chikkaballapur",
      total: 5000,
    },
    {
      latitude: 30.3647,
      longitude: 76.1456,
      title: "Rohini Packer",
      text: "Rohini Packer",
      total: 540,
    },
    {
      latitude: 27.786293,
      longitude: 81.482357,
      title: "Rohini Packer",
      text: "Rohini Packer",
      total: 1200,
    },
  ];

  const depotCoords = [
    {
      latitude: 28.0145,
      longitude: 79.5918,
      text: "Ahmedabad",
      title: "Ahmedabad",
      total: 2000,
    },
    {
      latitude: 19.43,
      longitude: 78.72,
      text: "Chikkaballapur",
      title: "Chikkaballapur",
      total: 5000,
    },
    {
      latitude: 35.3647,
      longitude: 76.1456,
      title: "Rohini Packer",
      text: "Rohini Packer",
      total: 540,
    },
    {
      latitude: 30.786293,
      longitude: 83.482357,
      title: "Rohini Packer",
      text: "Rohini Packer",
      total: 1200,
    },
  ];

  const newPlantsCoords = [
    {
      latitude: 22.171047,
      longitude: 76.474753,
      text: "Ahmedabad",
      title: "Ahmedabad",
      total: 460,
      //22.171047, 76.474753
    },
    {
      latitude: 25.785768,
      longitude: 88.143419,
      text: "Chikkaballapur",
      title: "Chikkaballapur",
      total: 1600,
      //25.785768, 93.143419
    },
  ];

  const valueToWidth = (val, plantflag) => {
    let v = val;
    // v > 10000 ? v = v / 5 : v = v;
    // const m = 0.0177; //Multiplying factor
    const m = 0.003; // this will be used for 10000 - 20000
    let diff1 = v - 246;
    let addPixels = diff1 * m;
    let out = 30 + addPixels;
    // let out = v/200; // 500 - exisint and new plant, 200 : depots

    // let out;

    // if (plantflag == "Depot") {
    //   out = v / 200;
    // }
    // else {
    //   out = v / 500;
    // }

    console.log("v : " + v + "out : " + out);
    return out;
  };

  const valueToFont = (val) => {
    let v = val;
    // v > 10000 ? v = v / 5 : v = v;
    // const m = 0.00212; //Multiplying factor
    const m = 0.0005; // this will be used for 10000 - 20000
    let diff1 = v - 246;
    let addPixels = diff1 * m;
    let out = 7 + addPixels;

    // let out = 12;
    return out;
  };

  let popUpContent = [];
  let popupPosition = "";
  function mouseOverLineString(e) {
    popUpContent = [];
    const ele = e.target?.element;
    if (e.target && e.target?.options?.position?.length > 0) {
      console.log(e.target?.options, "contentttt");
      if (e.target?.options?.htmlContent.toString().includes("marker1")) {
        popupPosition = "Depo";
      } else if (
        e.target?.options?.htmlContent.toString().includes("marker2")
      ) {
        popupPosition = "Packaging";
      } else {
        popupPosition = "Factory";
      }
      popUpContent.push(e.target?.options?.position, e.target?.options?.text);
    }
  }

  const onClick = (e) => {
    atlas.Popup(true);
  };

  const eventToMarker = [
    { eventName: "mousemove", callback: mouseOverLineString },
  ];

  const renderPoint = (data) => {
    let point1 = data.source;
    let point2 = data.destination;
    let out = curvePlot(point1, point2);
    return (
      <AzureMapFeature
        key={"Line String Feature"}
        id={"Line Strign ID"}
        type={"LineString"}
        coordinates={[...out]}
      />
    );
  };
  function renderHTMLPoint() {
    const rendId = Math.random();
    return (
      <>
        {selectedCategoryId === 1 ? (
          <>
            {coordinates.map((coordinate, idx) => {
              return (
                <AzureMapHtmlMarker
                  key={idx}
                  markerContent={
                    <div title={coordinate.tooltip}>
                      <img className={"marker-1-style"} src={marker1} />
                    </div>
                  }
                  options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                  events={eventToMarker}
                />
              );
            })}
          </>
        ) : (
          <>
            {nutritionCoordinates?.map((coordinate, idx) => {
              return (
                <AzureMapHtmlMarker
                  key={idx}
                  markerContent={
                    <div>
                      <img className={"marker-1-style"} src={marker1} />
                    </div>
                  }
                  options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                  events={eventToMarker}
                />
              );
            })}
          </>
        )}
      </>
    );
  }

  function renderFactoryPoints() {
    const rendId = Math.random();
    setExistingPlantShow(false);
    if (resultData?.factoryCoords?.length > 0) {
      setExistingPlantShow(true);
    }
    return (
      <>
        {/* {selectedCategoryId === 1 ? <> */}
        {true ? (
          <>
            {/* {factoryCoords.map((coordinate, idx) => { */}
            {resultData &&
              resultData?.factoryCoords &&
              resultData?.factoryCoords.map((coordinate, idx) => {
                return (
                  <AzureMapHtmlMarker
                    key={idx}
                    markerContent={
                      // <div title={coordinate.tooltip}>
                      //   {/* <img className={"marker-3-style"} src={marker3} onMouseEnter={mouseOverLineString} /> */}
                      //   <div style={{
                      //     width: valueToWidth(coordinate.total, coordinate.text) + "px",
                      //     height: valueToWidth(coordinate.total, coordinate.text) + "px",
                      //     fontSize: valueToFont(coordinate.total) + "px"
                      //   }} className={"bubble-in-map plants"}>
                      //     {coordinate.total}
                      //   </div>
                      // </div>
                      <div title={coordinate.tooltip}>
                        <img
                          className={"marker-3-style2"}
                          src={processingPlantCapacity}
                        />
                      </div>
                    }
                    options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                    events={eventToMarker}
                  />
                );
              })}
          </>
        ) : (
          <>
            {nutritionFactoryCoords?.map((coordinate, idx) => {
              {
                /* {resultData && resultData?.factoryCoords && resultData?.factoryCoords.map((coordinate, idx) => { */
              }
              return (
                <AzureMapHtmlMarker
                  key={idx}
                  markerContent={
                    <div>
                      <img
                        className={"marker-3-style"}
                        src={marker3}
                        onMouseEnter={mouseOverLineString}
                      />
                    </div>
                  }
                  options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                  events={eventToMarker}
                />
              );
            })}
          </>
        )}
      </>
    );
  }

  function renderDepotPoints() {
    const rendId = Math.random();
    setDepotShow(false);
    if (resultData?.depotCoords?.length > 0) {
      setDepotShow(true);
    }
    return (
      <>
        {/* {selectedCategoryId === 1 ? <> */}

        {/* {depotCoords.map((coordinate, idx) => { */}
        {resultData &&
          resultData?.depotCoords &&
          resultData?.depotCoords.map((coordinate, idx) => {
            return (
              <AzureMapHtmlMarker
                key={idx}
                markerContent={
                  <div title={coordinate.tooltip}>
                    {/* <img className={"marker-3-style"} src={marker3} onMouseEnter={mouseOverLineString} /> */}
                    <div
                      style={{
                        width:
                          valueToWidth(coordinate.total, coordinate.text) +
                          "px",
                        height:
                          valueToWidth(coordinate.total, coordinate.text) +
                          "px",
                        fontSize: valueToFont(coordinate.total) + "px",
                      }}
                      className={"bubble-in-map depots"}
                    >
                      {coordinate.total}
                    </div>
                  </div>
                }
                options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                events={eventToMarker}
              />
            );
          })}
      </>
    );
  }

  function renderNewPlantPoints() {
    const rendId = Math.random();
    setNewPlantShow(false);
    if (resultData?.newPlantsCoords?.length > 0) {
      setNewPlantShow(true);
    }
    return (
      <>
        {/* {selectedCategoryId === 1 ? <> */}

        {/* {newPlantsCoords.map((coordinate, idx) => { */}
        {resultData &&
          resultData?.newPlantsCoords &&
          resultData?.newPlantsCoords.map((coordinate, idx) => {
            return (
              <AzureMapHtmlMarker
                key={idx}
                markerContent={
                  // <div title={coordinate.tooltip}>
                  //   {/* <img className={"marker-3-style"} src={marker3} onMouseEnter={mouseOverLineString} /> */}
                  //   <div style={{
                  //     width: valueToWidth(coordinate.total, coordinate.text) + "px",
                  //     height: valueToWidth(coordinate.total, coordinate.text) + "px",
                  //     fontSize: valueToFont(coordinate.total) + "px"
                  //   }} className={"bubble-in-map newplants"}>
                  //     {coordinate.total}
                  //   </div>
                  // </div>
                  <div title={coordinate.tooltip}>
                    <img className={"marker-3-style2"} src={processingPlant} />
                  </div>
                }
                options={{ ...azureHtmlMapMarkerOptions(coordinate) }}
                events={eventToMarker}
              />
            );
          })}
      </>
    );
  }

  function renderPackagingPoints() {
    const rendId = Math.random();
    return (
      <>
        {nutritionPackaging?.map((packaging, idx) => {
          return (
            <AzureMapHtmlMarker
              key={idx}
              markerContent={
                <div>
                  <img className={"marker-1-style"} src={products} />
                </div>
              }
              options={{ ...azureHtmlMapMarkerOptions(packaging) }}
              events={eventToMarker}
            />
          );
        })}
      </>
    );
  }

  function azureHtmlMapMarkerOptions(coordinate) {
    return {
      //position: [coordinate.latitude, coordinate.longitude],
      position: [coordinate.longitude, coordinate.latitude],
      text: coordinate.text,
      title: coordinate.title,
    };
  }

  const curvePlot = (point1, point2) => {
    let startX = point1[0];
    let startY = point1[1];

    let endX = point2[0];
    let endY = point2[1];

    let centerX = (startX + endX) / 2;
    let centerY = (startY + endY) / 2;

    let slope = (endY - startY) / (endX - startX);
    let c1 = endY - slope * endX;
    let nslope = (1 / slope) * -1;
    let c = slope * centerX + centerX / slope + c1; //c for perpendicular line
    //eq of perpendicular line : y = (-1/slope)x + c

    //Now solve quadratic eq: ax2 + bx + c2 = 0
    let a = 1 + nslope * nslope;
    let b = 2 * nslope * c - 2 * centerX - 2 * nslope * centerY;
    let c2 =
      centerX * centerX + centerY * centerY + c * c - 2 * centerY * c - 2;

    let reqX = (-b - Math.sqrt(Math.abs(b * b - 4 * a * c2))) / (2 * a);
    let reqY = nslope * reqX + c;

    let out = [];
    out.push(point1);

    let bezierX = reqX;
    let bezierY = reqY;

    for (let t = 0.0; t <= 1; t += 0.01) {
      let x =
        (1 - t) * (1 - t) * startX + 2 * (1 - t) * t * bezierX + t * t * endX;
      let y =
        (1 - t) * (1 - t) * startY + 2 * (1 - t) * t * bezierY + t * t * endY;
      out.push([x, y]);
    }
    out.push(point2);
    return out;
  };
  // curvePlot?.setProperty('strokeColor', 'red')

  const renderMarker = () => {
    const rendId = Math.random();

    return (
      <AzureMapFeature
        key={rendId}
        id={rendId.toString()}
        type="Point"
        coordinate={coordinates}
        nutritionPackaging={nutritionPackaging}
        // state = {states}
        properties={{
          title: "Pin",
          icon: "pin-round-blue",
        }}
      />
    );
  };

  const calculateDistance = (point1, point2) => {
    let dis =
      Math.pow(point1[0] - point2[0], 2) + Math.pow(point1[1] - point2[1], 2);
    return Math.sqrt(dis);
  };

  <AzureMapFeature
    key={data.licensePlate}
    id={data.licensePlate}
    type="Point"
    coordinate={data}
    packaging={data}
    state={data}
    properties={{
      id: data.licensePlate,
      popUpProp: data,
    }}
  />;

  const MarkersExample = () => {
    const [popupProperties, setPopupProperties] = useState("");
    const [popupOptions, setPopupOptions] = useState({});
    const option = useMemo(() => {
      return {
        authOptions: {
          authType: AuthenticationType.subscriptionKey,
          subscriptionKey: key,
        },
        center: [77.580643, 20.972442],
        zoom: 3.4,
        view: "Auto",
        visibility: "off",
      };
    }, []);

    var popup = new atlas.Popup({});
    const mapRef = useRef(null);

    const handleZoom = (e) => {
      const zoomLevel = e?.map?.map?.getZoom();
      if (zoomLevel > 0) {
        let layers = e?.map?.map?.getStyle().layers;

        for (let i = 0; i < layers.length; i++) {
          if (
            layers[i].type == "symbol" &&
            layers[i].source == "vectorTiles" &&
            layers[i].layout &&
            layers[i].layout["text-field"] &&
            layers[i].layout["text-field"] !== ""
          ) {
            e?.map?.map?.setLayoutProperty(layers[i].id, "visibility", "none");
          }
        }
      } else {
        let layers = e?.map?.map?.getStyle().layers;
        for (let i = 0; i < layers.length; i++) {
          if (
            layers[i].type == "symbol" &&
            layers[i].source == "vectorTiles" &&
            layers[i].layout &&
            layers[i].layout["text-field"] &&
            layers[i].layout["text-field"] !== ""
          ) {
            e?.map?.map.setLayoutProperty(layers[i].id, "visibility", "none");
          }
        }
      }
    };
    useEffect(() => {
      // console.log(popupOptions, "popupOptions")
    }, [popupOptions]);

    const memoizedMarkerRender = useMemo(
      () => points?.map((el) => renderPoint(el)),
      []
    );

    const nutritionMemoizedMarkerRender = useMemo(
      () => nutritionPoints?.map((el) => renderPoint(el)),
      []
    );

    const wrapperStyles = {
      map: {
        height: "700px",
        width: "100%",
      },
      wrapper: {
        padding: "15px",
        marginTop: "15px",
      },
      buttonContainer: {
        display: "grid",
        gridAutoFlow: "column",
        gridGap: "10px",
        gridAutoColumns: "max-content",
        padding: "10px 0",
      },
      buttons: {
        padding: "15px",
        flex: 1,
      },
      popupStyles: {
        padding: "20px",
        color: "black",
      },
    };

    return (
      <>
        <AzureMapsProvider>
          <div style={wrapperStyles.map}>
            <AzureMap
              events={{
                wheel: (e) => {
                  let z = e?.map?.map?.getZoom();
                },
              }}
              options={option}
            >
              <AzureMapDataSourceProvider
                events={{
                  dataadded: (e) => {
                    //    console.log("Data on source added", e);
                  },
                }}
                id={"routeExample AzureMapDataSourceProvider"}
                options={{
                  // This sample shows how to apply a stroke gradient to a line on the map.\
                  // In order to apply this feature to a line, the data source must have the lineMetrics option set to true.
                  lineMetrics: true,
                }}
              >
                <AzureMapLayerProvider
                  id={"routeExample AzureMapLayerProvider"}
                  options={{
                    lineJoin: "round",
                    //  pathType: 'original',
                    lineCap: "round",
                    // width: 3,
                    // lineDash: [40,10], // <- [dashLength, dashSpace]
                    strokeGradient: [
                      "interpolate",
                      ["linear"],
                      ["line-progress"],
                      0,
                      "#73706E",
                    ],
                  }}
                  events={{
                    mouseOverLineString: (e) => {
                      //     console.log("liner");
                    },
                    wheel: (e) => {
                      handleZoom(e);
                    },
                    mouseleave: () => {
                      setPopupOptions(() => {});
                    },
                    // mouseenter: mouseOverLineString,
                    mousemove: (e) => {
                      //   console.log("shapes", e?.shapes);
                      // var popupTemplate = '<div class="customInfobox"><div class="name">{name}</div>{description}</div>';
                      // var content, coordinate;
                      // var properties = e.shapes[0].getProperties();
                      if (e.shapes && e.shapes.length > 0) {
                        // var content, coordinate;
                        // var properties = e.shapes[0].getProperties();
                        // content = popupTemplate.replace(/{name}/g, properties.name).replace(/{description}/g, properties.description);
                        // coordinate = e.shapes[0].getCoordinates();
                        // console.log("shapes", e?.shapes);
                        const prop = e.target?.options;
                        // Set popup options
                        setPopupOptions({
                          ...popupOptions,
                          position: new data.Position(
                            e?.position[0],
                            e?.position[1]
                          ),
                          pixelOffset: [0, -8],
                        });
                        setPopupProperties("Position: " + popupPosition);
                        // var popup = new atlas.Popup({
                        //   pixelOffset: [0, -18],
                        //   closeButton: false
                        // });
                        // popup.setOptions({
                        //   content: "Hello",
                        //   //Update the popup's position with the symbol's coordinate.
                        //   position: e.shapes[0].getCoordinates(),
                        //   pixelOffset: [0, -18]
                        // })
                        // popup.open();
                        if (prop?.text)
                          // Set popup properties from Feature Properties that are declared on create Feature
                          setPopupProperties([...popupProperties, prop?.text]);
                      }
                    },
                  }}
                  lifecycleEvents={{
                    layeradded: (e) => {
                      //     console.log("LAYER ADDED TO MAP", e);
                    },
                  }}
                  type={"LineLayer"}
                />
                {selectedCategoryId === 1
                  ? memoizedMarkerRender
                  : nutritionMemoizedMarkerRender}
                {/* {map1Render} */}
                {renderHTMLPoint()}
                {show2 ? renderDepotPoints() : null}

                {show3 ? renderNewPlantPoints() : null}
                {show1 ? renderFactoryPoints() : null}

                {/* {renderPackagingPoints()} */}
              </AzureMapDataSourceProvider>

              <AzureMapPopup
                isVisible={popupOptions ? true : false}
                options={popupOptions}
                popupContent={
                  <>
                    <div style={{ padding: "8px" }}>
                      <span>
                        {popupProperties}
                        <br /> City: {popUpContent[1]}
                      </span>
                    </div>
                  </>
                }
                // <div style={{ padding: "8px 16px" }}>
                //   <h3>{popupOptions?.data && "Position: " + popupOptions?.data[0]?.positions}</h3>
                //   <h5>{popupOptions?.data && "City: " + popupOptions?.data[0]?.City}</h5>
                // </div> // Inject your JSX
              />
            </AzureMap>
          </div>
        </AzureMapsProvider>
      </>
    );
  };

  const renderLegendOptions = () => {
    return (
      <div className="CGOlegends-panel">
        <h3>Showing</h3>
        <br></br>
        {existingPlantShow && (
          <ul>
            {/* <li><div className='existing-plants'></div></li> */}
            <li>
              <img src={processingPlantCapacity}></img>
            </li>
            <li>
              <span>Existing Plants</span>
            </li>
            <li></li>
            <li>
              <input
                checked={show1}
                onChange={(v) => setShow1(v.target.checked)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>
        )}
        {newPlantShow && (
          <ul>
            {/* <li><div className='new-plants'></div></li> */}
            <li>
              <img src={processingPlant}></img>
            </li>
            <li>
              <span>New Plants</span>
            </li>
            <li>
              <input
                checked={show3}
                onChange={(v) => setShow3(v.target.checked)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>
        )}

        {depotShow && (
          <ul className="depots-legend">
            <li>
              <div className="depots"></div>
            </li>
            <li>
              <span>Depots</span>
            </li>
            <li>
              <input
                checked={show2}
                onChange={(v) => setShow2(v.target.checked)}
                type="checkbox"
                className="pull-right"
              />
            </li>
          </ul>
        )}
      </div>
    );
  };

  return (
    <div className="App">
      {/* legends info */}

      <div className="map-legend" onClick={() => setshowLegendDetails(true)}>
        {/* <span><img src={locator} ></img></span> */}
        <span className="direction-symbol">&#171; &nbsp;</span>
        <span>Legend</span>
        {showLegendDetails && (
          <span
            href="#"
            onClick={(e) => {
              e.stopPropagation();
              setshowLegendDetails(false);
            }}
          >
            &nbsp;&#10060;
          </span>
        )}
      </div>

      {showLegendDetails && renderLegendOptions()}
      <div className="over">
        <MarkersExample />
      </div>
    </div>
  );
}
